import { Paper, Typography, useMediaQuery } from "@material-ui/core";
import { useState } from "react";
import getSessionStorage from "utils/getSessionStorage";
import useStyles from "./style";
import CategoryDonughtChart from "components/Risk/AspectImpact/AspectImpactRegister/AspectImpactDashboard/CategoryDonughtChart";
import { Modal, Table, Tag, Tooltip } from "antd";
import AspectTrendLineChart from "components/Risk/AspectImpact/AspectImpactRegister/AspectImpactDashboard/AspectTrendLineChart";
import { AiOutlineArrowsAlt } from "react-icons/ai";
import CloseIconImageSvg from "assets/documentControl/Close.svg";

type Props = {
  formData: any;
  impactGroupedData?: any;
  aspectGroupedData?: any;
  topTenData?: any;
  tableFilters?: any;
  setTableFilters?: any;
  tags?: any;
  tagsWithoutDeptFilter?: any;
};

const AspImpGraphSection = ({
  formData,
  impactGroupedData,
  aspectGroupedData,
  topTenData,
  tableFilters,
  setTableFilters,
  tags,
  tagsWithoutDeptFilter,
}: Props) => {
  const matches = useMediaQuery("(min-width:820px)");
  const smallScreen = useMediaQuery("(min-width:450px)");
  const userDetails = getSessionStorage();
  const classes = useStyles();

  const [isModalOpenForCategory, setIsModalOpenForCategory] = useState(false);

  const showModalForCategory = () => {
    setIsModalOpenForCategory(true);
  };
  const handleOkForCategory = () => {
    setIsModalOpenForCategory(false);
  };

  const handleCancelForCategory = () => {
    setIsModalOpenForCategory(false);
  };

  const [isModalOpenForScore, setIsModalOpenForScore] = useState(false);

  const showModalForScore = () => {
    setIsModalOpenForScore(true);
  };
  const handleOkForScore = () => {
    setIsModalOpenForScore(false);
  };

  const handleCancelForScore = () => {
    setIsModalOpenForScore(false);
  };

  const impactCountColumns = [
    {
      title: "Impact Category",
      dataIndex: "impactTypeName",
      key: "impactTypeName",
      //   width: 350,
    },
    {
      title: "Count",
      dataIndex: "count",
      key: "count",
      //   render: (text: any) => moment(text).format("DD/MM/YYYY HH:mm"),
    },
  ];

  const topTenAspImpColumns = [
    {
      title: "Dept/Vertical",
      dataIndex: "entityName",
      key: "entityName",
    },
    {
      title: "Stage",
      dataIndex: "jobTitle",
      key: "jobTitle",
      render: (text: any, record: any) => {
        let displayText = text;
        let isTruncated = false;

        if (text && text.length > 30) {
          displayText = text.substring(0, 30) + "...";
          isTruncated = true;
        }
        return isTruncated ? (
          <Tooltip title={text}>
            <div
              style={{
                verticalAlign: "top", // Align text to the top
                display: "flex",
                alignItems: "center",
                // textDecorationLine: "underline",
                // cursor: "pointer",
                // display: "block", // Make the content behave like a block element
              }}
              //   onClick={() => handleOpenHiraView(record)}
            >
              <span style={{ textTransform: "capitalize" }}>{displayText}</span>
            </div>
          </Tooltip>
        ) : (
          <div
            style={{
              verticalAlign: "top", // Align text to the top
              display: "flex",
              alignItems: "center",
              //   textDecorationLine: "underline",
              //   cursor: "pointer",
              // display: "block", // Make the content behave like a block element
            }}
            // onClick={() => handleOpenHiraView(record)}
          >
            <span style={{ textTransform: "capitalize" }}>{displayText}</span>
          </div>
        );
      },
    },
    {
      title: "Activity",
      dataIndex: "activity",
      key: "activity",
      render: (text: any, record: any) => {
        let displayText = text;
        let isTruncated = false;

        if (text && text.length > 30) {
          displayText = text.substring(0, 30) + "...";
          isTruncated = true;
        }
        return isTruncated ? (
          <Tooltip title={text}>
            {/* <div
              style={{
                verticalAlign: "top", // Align text to the top
                display: "flex",
                alignItems: "center",
                textDecorationLine: "underline",
                cursor: "pointer",
                // display: "block", // Make the content behave like a block element
              }}
              onClick={() => handleOpenHiraView(record)}
            > */}
            <span style={{ textTransform: "capitalize" }}>{displayText}</span>
            {/* </div> */}
          </Tooltip>
        ) : (
          //   <div
          //     style={{
          //       verticalAlign: "top", // Align text to the top
          //       display: "flex",
          //       alignItems: "center",
          //       textDecorationLine: "underline",
          //       cursor: "pointer",
          //       // display: "block", // Make the content behave like a block element
          //     }}
          //     // onClick={() => handleOpenHiraView(record)}
          //   >
          <span style={{ textTransform: "capitalize" }}>{displayText}</span>
          //   </div>
        );
      },
    },
    {
      title: "Score",
      dataIndex: "postMitigationScore",
      key: "postMitigationScore",
      //   render: (text: any) => moment(text).format("DD/MM/YYYY HH:mm"),
    },
  ];

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-start", // Changed to flex-start to align items from the start
        flexWrap: "wrap",
        padding: "15px 0",
        margin: matches ? "3px 45px 10px 45px" : "3px 5px 10px 5px",
      }}
    >
      <Paper
        elevation={3}
        style={{
          width: matches ? "47%" : "100%", // Adjusted width to fit two papers per row
          height: "300px", // Set a fixed height
          margin: matches ? "15px" : "0px",
          padding: matches ? "20px" : "5px",
          display: "flex",
          flexDirection: "column", // Align items vertically
          justifyContent: matches ? "center" : "start",
          boxShadow: "none", // Remove box shadow
          border: "1px solid #b3a087",
          position: "relative", // Ensure proper positioning for arrow

        }}
      >
        {!!aspectGroupedData?.labels?.length && (
          <>
            {matches ? (
              <div style={{ display: "flex", justifyContent: "center" }}>
                {tags?.length ? (
                  <>
                    {tags?.map((tag: any, index: any) => (
                      <Tag color={tag?.color} key={index}>
                        {tag?.tagName}
                      </Tag>
                    ))}
                  </>
                ) : (
                  <></>
                )}
              </div>
            ) : null}
          <CategoryDonughtChart
            impactTypeCounts={impactGroupedData}
            setTableFilters={setTableFilters}
            tags={tags}
          />
          </>
        )}
          
        {matches ? (
             <div
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
            }}
          >
            <AiOutlineArrowsAlt onClick={showModalForCategory} />
          </div>
        ) : null}
      </Paper>

      <Paper
        elevation={3}
        style={{
          width: matches ? "45%" : "100%", // Maintain width consistency
          height: "300px", // Set fixed height
          overflow: "auto", // Make it scrollable
          margin: matches ? "15px" : "0px",
          padding: matches ? "20px" : "5px",
          display: "flex",
          flexDirection: "column", // Align items vertically
          justifyContent: matches ? "center" : "start",
          boxShadow: "none", // Remove box shadow
          border: "1px solid #b3a087",
          position: "relative", // Ensure proper positioning for arrow
        }}
      >
        {!!aspectGroupedData?.labels?.length && (
          <>
            {matches ? (
              <div style={{ display: "flex", justifyContent: "center" }}>
                {tags?.length ? (
                  <>
                    {tags?.map((tag: any, index: any) => (
                      <Tag color={tag?.color} key={index}>
                        {tag?.tagName}
                      </Tag>
                    ))}
                  </>
                ) : (
                  <></>
                )}
              </div>
            ) : null}
            <AspectTrendLineChart data={aspectGroupedData} />
          </>
        )}

        {matches ? (
          <div
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
            }}
          >
            <AiOutlineArrowsAlt onClick={showModalForScore} />
          </div>
        ) : null}
      </Paper>

      <Paper
        elevation={3}
        style={{
          width: matches ? "47%" : "100%", // Maintain width consistent with other Papers
          height: "400px", // Set a fixed height
          overflow: "auto", // Make it scrollable
          margin: matches ? "15px" : "0px",
          padding: matches ? "20px" : "5px",
          display: "flex",
          flexDirection: "column", // Align items vertically
          boxShadow: "none", // Remove box shadow
          border: "1px solid #b3a087",
          // justifyContent: "center",
        }}
      >
        <div className={classes.tableContainer}>
          {matches ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              {tags?.length ? (
                <>
                  {tags?.map((tag: any, index: any) => (
                    <Tag color={tag?.color} key={index}>
                      {tag?.tagName}
                    </Tag>
                  ))}
                </>
              ) : (
                <></>
              )}
            </div>
          ) : null}
          <Typography
            variant="h6"
            align="center"
            gutterBottom
            style={{ fontSize: "16px", color: "black" }}
          >
            By Impact Type
          </Typography>
          <Table
            columns={impactCountColumns}
            dataSource={impactGroupedData}
            pagination={false}
          />
        </div>
      </Paper>
      <Paper
        elevation={3}
        style={{
          width: matches ? "45%" : "100%", // Maintain width consistent with other Papers
          height: "400px", // Set a fixed height
          overflow: "auto", // Make it scrollable
          margin: matches ? "15px" : "0px",
          padding: matches ? "20px" : "5px",
          display: "flex",
          flexDirection: "column", // Align items vertically
          boxShadow: "none", // Remove box shadow
          border: "1px solid #b3a087",
          // justifyContent: "center",
        }}
      >
        <div className={classes.tableContainer}>
          {matches ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              {tags?.length ? (
                <>
                  {tags?.map((tag: any, index: any) => (
                    <Tag color={tag?.color} key={index}>
                      {tag?.tagName}
                    </Tag>
                  ))}
                </>
              ) : (
                <></>
              )}
            </div>
          ) : null}
          <Typography
            variant="h6"
            align="center"
            gutterBottom
            style={{ fontSize: "16px", color: "black" }}
          >
            Top 10 Risks
          </Typography>
          <Table
            columns={topTenAspImpColumns}
            dataSource={topTenData}
            pagination={false}
          />
        </div>
      </Paper>

      <Modal
        // title="Filter By Unit"
        open={isModalOpenForCategory}
        onOk={handleOkForCategory}
        onCancel={handleCancelForCategory}
        width={800}
        style={{ display: "flex", justifyContent: "center" }}
        footer={null}
        bodyStyle={{
          width: "800px",
          display: "flex",
          justifyContent: "center",
        }}
        closeIcon={
          <img
            src={CloseIconImageSvg}
            alt="close-drawer"
            style={{
              width: "30px",
              height: "38px",
              cursor: "pointer",
              marginTop: "-5px",
            }}
          />
        }
      >
        <div
          style={{
            width: matches ? "400px" : "96%", // Adjusted width to fit two papers per row
            height: "450px",
            // display: "flex",
            // justifyContent: "center",
          }}
        >
          <CategoryDonughtChart
            impactTypeCounts={impactGroupedData}
            setTableFilters={setTableFilters}
            tags={tags}
          />
        </div>
      </Modal>

      <Modal
        // title="Filter By Unit"
        open={isModalOpenForScore}
        onOk={handleOkForScore}
        onCancel={handleCancelForScore}
        width={800}
        style={{ display: "flex", justifyContent: "center" }}
        bodyStyle={{
          width: "800px",
          display: "flex",
          justifyContent: "center",
        }}
        footer={null}
        closeIcon={
          <img
            src={CloseIconImageSvg}
            alt="close-drawer"
            style={{
              width: "30px",
              height: "38px",
              cursor: "pointer",
              marginTop: "-5px",
            }}
          />
        }
      >
        <div>
          <div style={{ display: "flex", justifyContent: "center" }}>
            {tags?.length ? (
              <>
                {tags?.map((tag: any, index: any) => (
                  <Tag color={tag.color} key={index}>
                    {tag.tagName}
                  </Tag>
                ))}
              </>
            ) : (
              <></>
            )}
          </div>
          <div
            style={{
              width: "550px",
              height: "400px",
              // marginTop: "30px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <AspectTrendLineChart
              data={aspectGroupedData}
              //  tags={tags}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default AspImpGraphSection;
